import styled, { keyframes } from "styled-components";

import designSystemColors from "../../styles";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Container = styled.div`
  width: 100%;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4rem;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h1`
  font-size: 1.7rem;
  font-weight: 600;
  color: ${designSystemColors.textDark};
`;

export const Description = styled.span`
  font-size: 1.5rem;
  font-weight: 500;
  color: ${designSystemColors.textDescription};
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
`;

export const ActivateSSOButton = styled.button.attrs(() => ({
  type: "button",
}))<React.ButtonHTMLAttributes<HTMLButtonElement>>`
  width: 30%;
  height: 40px;
  border-radius: 4px;
  border: none;
  background-color: ${designSystemColors.secondaryButtons};
  color: ${designSystemColors.textGeneralButtons};
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  transition: 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;

export const CancelButton = styled.button.attrs(() => ({
  type: "button",
}))<React.ButtonHTMLAttributes<HTMLButtonElement>>`
  width: 30%;
  height: 40px;
  border-radius: 4px;
  border: none;
  border: 1px solid ${designSystemColors.cancelButtons};
  background-color: ${designSystemColors.background};
  color: ${designSystemColors.cancelButtons};
  text-align: center;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 700;
  transition: 0.2s;

  &:hover {
    cursor: pointer;
    opacity: 0.5;
  }
`;

export const Loader = styled.div`
  border: 4px solid ${designSystemColors.background};
  border-top: 4px solid ${designSystemColors.secondaryButtons};
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: ${spin} 1.5s linear infinite;
`;
